import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/update-items/global'

export const UPDATE_ITEMS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
